import { LOGIN_VALUE_KEY_NOT_VERIFIED } from '../base/constants';

/* Save not verified login value to storage */
export const getNotVerifiedLoginValueFromStorage = () => {
    return localStorage.getItem(LOGIN_VALUE_KEY_NOT_VERIFIED) || undefined;
};

export const setNotVerifiedLoginValueToStorage = (value: string | undefined) => {
    if (value) {
        return localStorage.setItem(LOGIN_VALUE_KEY_NOT_VERIFIED, value);
    }
    localStorage.removeItem(LOGIN_VALUE_KEY_NOT_VERIFIED);
};
